import React from "react";
import ModalUI from "../legacy/Modal";
import { QueueModalActions, QueueModalTitle } from "../Queue/QueueModalParts";

type AvailabilityFormShellProps = {
  eyebrow: string;
  title: string;
  submitLabel: string;
  canSubmit: boolean;
  isSaving: boolean;
  onSubmit: () => void;
  onClose: () => void;
  /** Présent en modification : bouton « Supprimer » sous le formulaire. */
  onDelete?: () => void;
  deleteLabel?: string;
  children: React.ReactNode;
};

/**
 * Cadre commun des fenêtres de saisie de la disponibilité (plage, absence) :
 * titre, champs, suppression optionnelle et pied de fenêtre.
 */
const AvailabilityFormShell: React.FC<AvailabilityFormShellProps> = ({
  eyebrow,
  title,
  submitLabel,
  canSubmit,
  isSaving,
  onSubmit,
  onClose,
  onDelete,
  deleteLabel = "Supprimer",
  children,
}) => (
  <ModalUI
    isOpen
    onClose={() => {
      if (!isSaving) onClose();
    }}
    styles={{ width: "min(480px, 92vw)", padding: 0 }}
  >
    <form
      className="flex flex-col"
      onSubmit={(event) => {
        event.preventDefault();
        if (canSubmit && !isSaving) onSubmit();
      }}
    >
      <div className="space-y-4 px-6 pt-6">
        <QueueModalTitle eyebrow={eyebrow} title={title} />
        {children}
        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            disabled={isSaving}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-rose-600 hover:text-rose-700 disabled:opacity-50"
          >
            <i className="bx bx-trash text-base" aria-hidden /> {deleteLabel}
          </button>
        )}
      </div>
      <QueueModalActions
        onCancel={onClose}
        onConfirm={onSubmit}
        confirmLabel={submitLabel}
        confirmIcon="bx-check"
        confirmDisabled={!canSubmit || isSaving}
        isLoading={isSaving}
      />
    </form>
  </ModalUI>
);

export default AvailabilityFormShell;
